define('Components/RichTextWidget/js/views/RichTextWidgetInstanceView',['jquery','app','WidgetInstanceView','InternalLinkView',
        'template!Components/RichTextWidget/templates/richtext-default','template!Components/RichTextWidget/templates/richtext-pos-right'],
    function($,app,WidgetInstanceView,InternalLinkView,defaultTemplate,posRightTemplate){
    return WidgetInstanceView.extend({
        name:'RichTextWidgetInstanceView',
        getTemplate:function(){
            switch(this.model.getTemplate()){
                case "richtext-pos-right": return posRightTemplate; break;
                case 'richtext-default': default: return defaultTemplate; break;
            }
        },
        afterRender:function(){
            var self = this;
            self.listenTo(app,'change:scrollTop',self.onScroll);
            InternalLinkView.initializeLinksOfView(self);
        },
        onScroll: function(){
            var self = this;
            if(!self.$el.hasClass('active')) {
                if(app.get('scrollTop') > self.$el.offset().top - app.get('winH') + self.$el.height()){
                    self.$('.centered').addClass('active');
                }
            }
        }
    })
});
